// extracted by mini-css-extract-plugin
export default {"title":"FK_fpzjSNFaY6N_kHObj","wrap":"ZacXHQyHZsizJCOwy45p"};